import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eChuDeActionIds,
  IChuDeActionTypes,
} from "../../action-types/category/IChuDeActions";
import { rootActions } from "../../actions/rootActions";
import { chuDeApi } from "../../../api/category/chuDeApi";
import { ISMT_ChuDe } from "../../../model/respone/category/ISMT_ChuDe";

export function* chuDeSaga(): any {
  yield takeLatest(eChuDeActionIds.LOAD_START, loadWorker);
  yield takeLatest(eChuDeActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eChuDeActionIds.SAVE_START, saveWorker);
  yield takeLatest(eChuDeActionIds.IMPORT_START, importWorker);
}

function* loadWorker(action: IChuDeActionTypes): any {
  const res: IBaseRespone = yield call(
    chuDeApi.SelectVm,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.chuDe.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.chuDe.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* saveWorker(action: IChuDeActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as ISMT_ChuDe;
  if (payload.id > 0) {
    res = yield call(chuDeApi.Update, payload);
  } else {
    res = yield call(chuDeApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.chuDe.SAVE_SUCCESS(res.data));
    } else {
      yield put(rootActions.category.chuDe.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
  }
}

function* deleteWorker(action: IChuDeActionTypes): any {
  const res: IBaseRespone = yield call(
    chuDeApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.chuDe.DELETE_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.chuDe.DELETE_ERROR(res.message ?? "Có lỗi"));
  }
}

function* importWorker(action: IChuDeActionTypes): any {
  const res: IBaseRespone = yield call(
    chuDeApi.Import,
    action.payload as FormData
  );
  if (res.is_success) {
    yield put(rootActions.category.chuDe.IMPORT_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.chuDe.IMPORT_ERROR(res.message ?? "Có lỗi"));
  }
}
